import {
  useComponentInfo,
  useHttpClient,
  useModuleInfo,
  useModuleParams,
} from '@wix/yoshi-flow-bm';
import React, { ReactNode, useState } from 'react';
import { CairoProvider } from '../providers';
import { buildBMCairoEssentials } from './buildBMCairoEssentials';
import { useErrorMonitorCompat } from './errorMonitorCompat';
import { WixPatternsEssentialsOverrides } from '@wix/bex-core';
import { useExperimentsCompat } from './useExperimentsCompat';
import { usePlatformApiCompat } from './usePlatformApiCompat';

export interface WixPatternsBMProviderProps {
  overrides?: Partial<WixPatternsEssentialsOverrides>;
  children?: ReactNode;
  localCache?: boolean;
}

/**
 * @deprecated
 * use `WixPatternsBMProvider`
 */
export function CairoBMProvider({
  overrides,
  children,
  localCache,
}: WixPatternsBMProviderProps) {
  const moduleParams = useModuleParams();

  const moduleInfo = useModuleInfo();
  const componentInfo = useComponentInfo();

  const errorMonitor = useErrorMonitorCompat();

  const httpClient = useHttpClient();

  const experiments = useExperimentsCompat();
  const { onBeforeUnload } = usePlatformApiCompat();

  const [wixPatternsEssentialsOverrides] = useState(
    (): Partial<WixPatternsEssentialsOverrides> => ({
      onBeforeUnload,
      ...overrides,
    }),
  );

  const [cairoEssentials] = useState(() => {
    const flowAPI = {
      errorMonitor,
      httpClient,
      componentInfo,
      moduleInfo,
      moduleParams,
      experiments,
    };

    return buildBMCairoEssentials(flowAPI, {
      overrides: wixPatternsEssentialsOverrides,
    });
  });

  return (
    <CairoProvider value={cairoEssentials} localCache={localCache}>
      {children}
    </CairoProvider>
  );
}

export const WixPatternsBMProvider = CairoBMProvider;
